import { useAuth } from 'react-oidc-context'
import { Icon } from '../components/icons/Icon'
import { AccentPicker } from '../theme/AccentPicker'

/**
 * ADR-0048 (Phase A, #7) — the top-bar persona chip + real "Sign out" CTA (NavShell). Shows the
 * authenticated persona (`preferred_username`/`name` off the ID token claims — no extra backend
 * call needed for this label) and signs out via `react-oidc-context`'s `auth.signoutRedirect()`,
 * which clears the local session AND redirects through Keycloak's end-session endpoint — a real
 * logout, not merely a local state reset.
 *
 * IB-258 adds a small "Appearance" grouping — the accent colour picker
 * (`AccentPicker`, compact variant) — next to the topbar's existing
 * `ThemeToggle` (design doc §5). The `variant="full"` picker also lives in
 * `AdminSettingsScreen`'s Preferences tab, alongside the equivalent
 * full-variant `ThemeToggle` already there.
 */
export function UserMenu() {
  const auth = useAuth()

  if (!auth.isAuthenticated || !auth.user) {
    return null
  }

  const displayName =
    (auth.user.profile.name as string | undefined) ??
    (auth.user.profile.preferred_username as string | undefined) ??
    'Signed in'

  return (
    <div className="iw-user-menu">
      <AccentPicker />
      <span className="iw-user-menu__name">
        <Icon name="user" size={14} />
        {displayName}
      </span>
      <button
        type="button"
        className="iw-btn iw-btn--ghost iw-btn--sm"
        onClick={() => {
          void auth.signoutRedirect()
        }}
      >
        <Icon name="log-out" size={14} />
        Sign out
      </button>
    </div>
  )
}
